module.exports = __webpack_public_path__ + "static/media/btn_snake.dcbcaff6.png";